<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xBUilX/tc-custom/9780857908094.jpg?1705766094659" alt="This image is the cover for the book Cairngorms"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cairngorms
      </h1>
      <p class="bookDescription body article font2">
        <b>A travelogue exploring the colorful history of the Scottish mountain range, by the author of <i>The Unremembered Places</i>.</b><br/><br/><i>Cairngorms: A Secret History</i> is a series of journeys exploring barely known human and natural stories of the Cairngorm Mountains. It looks at a unique British landscape, its last great wilderness, with new eyes. History combines with travelogue in a vivid account of this elemental scenery. There have been rare human incursions into the Cairngorm plateau, and Patrick Baker tracks them down. He traces elusive wildlife and relives ghostly sightings on the summit of Ben Macdui.<br/><br/> From the search for a long-forgotten climbing shelter and the locating of ancient gem mines, to the discovery of skeletal aircraft remains and the hunt for a mysterious nineteenth-century aristocratic settlement, he seeks out the unlikeliest and most interesting of features in places far off the beaten track. The cultural and human impact of this stunning landscape and reflections on the history of mountaineering are the threads which bind this compelling narrative together.<br/><br/><b>Praise for <i>The Cairngorms</i></b><br/><br/><b>“Perfect . . . full of ghosts of walkers past.” —<i>Conde Nast Traveler</i></b><br/><br/><b>“Describing a series of walks, Baker illuminates the bleak landscape, revealing the many stories linked to its ruined bothies, ancient gem mines and even haunted summits.” —<i>FT Weekend</i></b><br/><br/><b>“Exploring the Cairngorms has been a lifetime fascination for Patrick Baker and in this book he generously shares the results.” —<i>Scotland Magazine</i></b><br/><br/><b>“Packed with great stories and vivid descriptions.” —<i>Scotland Outdoor</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patrick Baker
      </h2>
      
      <p class="authorDescription body article">Patrick Baker studied Business, Finance and Economics at the University of East Anglia and gained a postgraduate qualification in Publishing from the Robert Gordon University, Aberdeen. He has worked in the publishing industry for many years editing and producing academic journals and is currently a writer for an investment management company. A keen outdoor enthusiast, he has walked and climbed throughout Scotland and Europe. His book Walking in the Ochils, Campsie Fells and Lomond Hills was published in 2006.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Birlinn Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4cd7ac75